import { startOfDay } from 'date-fns'

interface TransactionsByDay<T> {
    date: Date
    transactions: T[]
}

export const groupByDay = <T extends { created_at?: string; timeForRow?: string }>(transactions: T[]) => {
    const groupedHistory: TransactionsByDay<T>[] = []

    let currentDay: TransactionsByDay<T>

    transactions.forEach(transaction => {
        if (!transaction.created_at && !transaction.timeForRow) {
            return
        }

        const date = startOfDay(new Date(transaction.timeForRow || transaction.created_at || ''))

        if (currentDay?.date.getTime() !== date.getTime()) {
            currentDay = {
                date,
                transactions: [],
            }
            groupedHistory.push(currentDay)
        }

        currentDay.transactions.push(transaction)
    })

    return groupedHistory
}
